// @flow

import React, { Component } from 'react';
import { Card, Button } from 'semantic-ui-react';
import ResourceImage from './ResourceImage';
import ResourceSelector from './ResourceSelector/index';

type Props = {
  children?: Element,
  resource?: BucketResource,
  resourceType: ResourceCategory,
  onSelected: (resource: BucketResource) => void,
  onDeleted: () => void,
};

type State = {
  selectorOpen: boolean,
};

class ResourceCard extends Component {
  props: Props;
  state: State;

  constructor(props: Props) {
    super(props);

    this.state = {
      selectorOpen: false,
    };
  }

  onShowSelector = () => this.setState({ selectorOpen: true });
  onHideSelector = () => this.setState({ selectorOpen: false });

  onResourceSelected = (resource: BucketResource) => {
    // Updating current image
    this.setState({
      selectorOpen: false,
    });

    this.props.onSelected(resource);
  };

  onResourceDeleted = () => {
    this.props.onDeleted();
  };

  render() {
    const { children, resource, resourceType, onDeleted } = this.props;
    const { selectorOpen } = this.state;

    const image = children || <ResourceImage resource={resource} />;

    return (
      <Card centered>
        {image}
        <Card.Content>
          <div className="ui two buttons">
            <Button
              type="button"
              basic
              color="green"
              onClick={this.onShowSelector}
            >
              Modifier
            </Button>
            {resource &&
              <Button type="button" basic color="red" onClick={onDeleted}>
                Supprimer
              </Button>}
          </div>
        </Card.Content>
        <ResourceSelector
          open={selectorOpen}
          resourceType={resourceType}
          onResourceSelected={this.onResourceSelected}
          onClose={this.onHideSelector}
        />
      </Card>
    );
  }
}

export default ResourceCard;



// WEBPACK FOOTER //
// ./src/shared/components/ResourceCard.js